function addLink() {
	if (copyState) {
		const body_element = document.getElementsByTagName('body')[0];

		let selection = window.getSelection();

		let pagelink = window.CC;

		let copytext = selection + pagelink;
		let newdiv = document.createElement('div');

		newdiv.style.position = 'absolute';
		newdiv.style.left = '-99999px';
		body_element.appendChild(newdiv);
		newdiv.innerHTML = copytext;
		selection.selectAllChildren(newdiv);
		window.setTimeout(function () {
			body_element.removeChild(newdiv);
		}, 0);
	}
}
document.oncopy = addLink;
